import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { StandardProposalProvider } from "presentation/store/StandardProposal/StandardProposalProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { StandardProposalMDView } from "presentation/view/section/StandardProposal/StandardProposalMDView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const StandardProposalContMain = () => {
    return <ANAInfoWrapper permission={Permission.STANDARD_PROPOSAL_MAINTENANCE}>
        <MessageBarWrapper>
            <StandardProposalProvider>
                <GridStyles/>
                <StandardProposalMDView/>
            </StandardProposalProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default StandardProposalContMain;